import { runBit } from './run-bit';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
runBit();
